import { request } from './request';
import { Pool, IPAddress } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

export const loadIPPools = (): Promise<Pool[]> => {
    const { Pools } = request();

    return Pools.poolsGet().then((resp) => resp.data);
};

export const loadPoolPrivateIp = (name: string): AxiosPromise<void | string[]> => {
    const { Pools } = request();
    return Pools.poolsByNameIpsGet(name);
};
export const addIPPool = (Name: string, Description: string): Promise<Pool> => {
    const { Pools } = request();
    return Pools.poolsPost({ Name, Description }).then((resp) => resp.data);
};
export const updateIPPool = (oldName: string, Name: string, Description: string): Promise<Pool> => {
    const { Pools } = request();
    return Pools.poolsByNamePut(oldName, { Name, Description }).then((resp) => resp.data);
};
export const deleteIPPool = (name: string): Promise<void> => {
    const { Pools } = request();
    return Pools.poolsByNameDelete(name).then((resp) => resp.data);
};
export const loadAllIPs = (): Promise<IPAddress[]> => {
    const { Pools } = request();
    return Pools.poolsIpsGet().then((resp) => resp.data);
};
export const moveIpToPool = (ip: string, targetPool: string): Promise<void> => {
    const { Pools } = request();
    return Pools.poolsIpsByIpPatch(ip, targetPool).then((resp) => resp.data);
};
